<template>
    <button
        class="o-w-service-info-tile w-service-info-tile"
        role="button"
        type="button"
        @click="handleClick"
    >
        <span class="w-service-info-tile__icon-container">
            <img 
                v-if="itemIcon"
                class="w-service-info-tile__icon"
                :src="itemIcon"
                :alt="`Image ${t(item, 'name')}`"
            >
        </span>
        <div class="w-service-info-tile__wrapper">
            <span class="w-service-info-tile__title">
                {{ itemName }}
            </span>
            <AItemInfoContrast
                :floor="itemName"
                :target-zone="targetZone"
            />
        </div>
    </button>
</template>

<script>
import { mapGetters } from 'vuex';

import AItemInfoContrast from '../../atoms/a-item-info-contrast/a-item-info-contrast';

export default {
    name: 'OWServiceInfoTile',
    components: {
        AItemInfoContrast
    },
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getCategoryById',
            'getDenormalisedObjectById'
        ]),
        itemName() {
            return this.t(this.item, 'name') || '';
        },
        targetZone() {
            return this.t(this.getCategoryById(this.item.lists.target_zone), 'name');
        },
        itemIcon() {
            return this.t(this.item, 'icon') || '';
        }
    },
    methods: {
        handleClick() {
            this.$emit('onClick', this.item);
        }
    }
}
</script>

<style lang="scss">
@import "o-w-service-info-tile";    
</style>